export default __webpack_public_path__ + "static/media/mortal-kombat-11.1c01ba3c.png";